import { createMongoAbility } from '@casl/ability';

export const createAbilityForUser = (permissions) => {
  return createMongoAbility(permissions);
};

export const isAllowed = (requiredPermissions, ability) => {
  return requiredPermissions.every((permission) => ability.can(...permission));
};
